import { render, staticRenderFns } from "./financeiro-gerenciamento-equipes.vue?vue&type=template&id=5421be96&scoped=true"
import script from "./financeiro-gerenciamento-equipes.vue?vue&type=script&lang=ts"
export * from "./financeiro-gerenciamento-equipes.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-gerenciamento-equipes.vue?vue&type=style&index=0&id=5421be96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5421be96",
  null
  
)

export default component.exports